import { render, staticRenderFns } from "./certificateListModal.vue?vue&type=template&id=4f7440a8&scoped=true"
import script from "./certificateListModal.vue?vue&type=script&lang=js"
export * from "./certificateListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7440a8",
  null
  
)

export default component.exports